
const Visualiser = require('../analysis/visualiser')

const Chart = require('chart.js')

const {get} = require('../request')
const {parse} = require('../html')
const layout = require('./word_frequency.html')
const chartLayout = require('./word_frequency_chart.html')
const description = require('./word_frequency_description.html')

const {posColour} = require('../pos')

const NAME = '단어 빈도'

const WordFrequency = class extends Visualiser {
    constructor(analysis, options={}) {
        super(NAME, analysis, {
            width: options.width || 24,
            height: options.height || 256,
            topN: 10,
            singleChar: true,
        })
    }
    parseInputs(form) {
        const topN = parseInt(form.querySelector('#topn').value)
        const singleChar = form.querySelector('#single-char').checked
        return {topN, singleChar}
    }
    dom() {
        const options = [5, 10, 15, 20, 30, 40, 50]
        const content = parse(layout, {options}).querySelector('#content')
        this.content = content

        const form = content.querySelector('form')
        form.addEventListener('submit', (event) => {
            event.preventDefault()

            Object.assign(this.options, this.parseInputs(form))
            this.update()

            return true
        })

        return content
    }
    update() {
        const charts = this.content.querySelector('#charts')
        const {topN, singleChar} = this.options
        
        const {host, port} = this.api
        get(host, port, `/document/${this.document.name}/tokens`, this.config.json()).then(({units}) => {
            const data = Object.values(units).map(({name, frequency}) => {
                const words = Object.entries(frequency)
                        .map(([t, f]) => ({text: t.split('/')[0], pos: t.split('/')[1], size: f}))
                        .sort((a, b) => b.size - a.size)
                        .filter(word => singleChar || word.text.length > 1)
                        .slice(0, topN)
                return ({name, words})
            })
            const max = data.map(({words}) => words[0].size).reduce((a, c) => c > a ? c : a, 0)
            const results = data.map((d) => this.chart(d, topN, max))
            charts.innerHTML = ''
            results.forEach(c => charts.appendChild(c))
        })

    }
    chart(data, topN, max) {
        const {words, name} = data

        const wrapper = parse(chartLayout, {name}).firstChild
        const canvas = document.createElement('canvas')

        canvas.width = this.options.width * topN
        canvas.height = this.options.height
        
        new Chart(canvas.getContext('2d'), {
            type: 'bar',
            data: {
                datasets: [{
                    label: '출현 빈도',
                    data: words.map(word => word.size),
                    backgroundColor: words.map(word => posColour(word.pos)),
                }],
                labels: words.map(word => word.text),
            },
            options: {
                responsive: false,
                legend: {
                    display: false,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            max: max,
                        }
                    }],
                }
            },
        })
        wrapper.appendChild(canvas)
        return wrapper
    }

}

module.exports = {
    name: NAME,
    add: (analysis) => new WordFrequency(analysis),
    description: description,
}
